module.exports = __webpack_public_path__ + "media/customizations/lmhh/logo-new-81b1c714de1bd1670b943ffef7bd3ecf.png";